import React from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { FooterBaseStyle } from './StorageCapacitySettingStyle';
import { useTranslation } from 'react-i18next';

type StorageCapacitySettingFooterProps = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
  buttonEnable: boolean;
};

const StorageCapacitySettingFooter: React.FC<StorageCapacitySettingFooterProps> = (props) => {
  const footerStyle = FooterBaseStyle();
  const { t, i18n } = useTranslation();

  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={footerStyle.buttonStyle}
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSaveButton();
          }}
        >
          {t('StorageCapacitySettingFooter.保存', '保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={footerStyle.buttonStyle}
          disabled={!props.buttonEnable}
          color="primary"
          disableElevation
          onClick={(e) => props.onClickCancelButton()}
        >
          {t('StorageCapacitySettingFooter.中止', '中止')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default StorageCapacitySettingFooter;
